
/*
 *   File : risk-confirm.js
 *   Author URI : https://evoqins.com
 *   Description : Confirm modal 
 *   Integrations : null
 *   Version : v1.1
 */

// Packages
import { Fragment, memo, useEffect } from "react";

// Custom components
import { PrimaryButton, SecondaryButton } from "../Buttons";
// import { ConsentCard } from "../Cards";
import { Icon } from "../Icon";

// Custom styles
import style from "../../Styles/Components/fund-allocation.module.scss";
import Color from '../../Styles/color.module.scss'
import { useNavigate } from "react-router-dom";


// type  1 ---- success
// else failed

const UpdateNomineeConfirmation = (props) => {
    const navigate = useNavigate();
    // const [acceptedTerms, setAcceptedTerms] = useState(false);


    async function _handleConfirm() {
        navigate("/nominee")
    }


    return (
        <Fragment>
            <div className={`modal fade ${style.e_confirm_modal}`}
                id="update-nominee"
                tabIndex="-1"
                aria-labelledby="update-nominee"
                aria-hidden="true"
                data-bs-backdrop="static"
                data-bs-keyboard="false" >
                <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                    <div className={`modal-content text-center padding-20px-lr py-3 ${style.e_content} `}>
                        <Icon icon="close-btn"
                            size={24}
                            id="close-modal"
                            data-bs-dismiss="modal"
                            stroke={Color.steel_blue}
                            className='cursor-pointer position-absolute right-16px top-16px d-none' />

                        <img src={require("../../Assets/Images/Modal/failed.png")}
                            alt="success"
                            draggable={false}
                            width={144}
                            height={144}
                            className="mx-auto" />
                        <h5 className="e-font-16 e-line-height-24 e-montserrat-semi-bold color-eerie-black mb-2">
                            Update nominee details
                        </h5>

                        <p className="e-montserrat-medium e-font-14 e-line-height-24 color-charcoal-gray mb-0 ">
                            As per SEBI guidelines, update your nominee details to avoid disruptions. Submit identity proof (PAN, Aadhaar, DL, or Passport), contact info, and address. For minors, guardian details are also required. Ensure all info matches official documents.
                        </p>
                        {/* <ConsentCard acceptedTerms={acceptedTerms} risk={true}
                            setAcceptedTerms={() => setAcceptedTerms(!acceptedTerms)} /> */}

                        <div className="row justify-content-center">
                            <div className="col-8">
                                <PrimaryButton label={"Update now"}
                                    cancel="modal"
                                    showLoader={props.loader}
                                    className="w-100 padding-12px-tb mt-4"
                                    onPress={_handleConfirm} />
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </Fragment>
    )
}

UpdateNomineeConfirmation.defaultProps = {
    closeModal: () => { },
    handleConfirm: () => { },
    loader: false
}

export default memo(UpdateNomineeConfirmation)